module.exports = __webpack_public_path__ + "img/foot-channel10.3654c4a8.png";